import { useQueryWithUserId } from '@northladder/services';

import { BIDS_API } from '../bidsAPIClient';

/**
 * React Query state key for fetch TIMED AUCTION TIME PERIOD api.
 */
const FETCH_TIMED_AUCTION_TIME_PERIOD_QUERY_KEY =
  'fetch-timed-auction-time-period-query-key';

interface IUseTimedAuctionTimePeriodQueryProps {
  isEnabled?: boolean;
}

/**
 * React Query hook for timed auction time period api management.
 * Calls `fetchTimedAuctionTimePeriod` and provides error/loading/success state.
 */
export const useTimedAuctionTimePeriodQuery = (
  options?: IUseTimedAuctionTimePeriodQueryProps
) => {
  const { isEnabled = true } = options || {};
  const { data, isError, error, isPending, refetch, isFetching } =
    useQueryWithUserId({
      enabled: isEnabled,
      queryKey: [FETCH_TIMED_AUCTION_TIME_PERIOD_QUERY_KEY],
      queryFn: BIDS_API.fetchTimedAuctionTimePeriod,
      retry: false,
    });

  return {
    data,
    error,
    isError,
    isFetching,
    isPending,
    refetch,
  };
};
